module.exports = __webpack_public_path__ + "img/526606d7017d270bba52d65f9aa89f9c.png";